



















import Element from '../../../mixins/element';
import { Component } from 'vue-property-decorator';

@Component
export default class Expiry extends Element {
    public toMount() {
        this.onLoading(false);
    }

    public toValidate(): boolean {
        return true;
    }

    public toClear(): void {}

    public toDestroy(): void {}

    public toFocus(): void {}

    public toBlur(): void {}
}
